const defaultValue = {
    USER_ID: `LV8-fM_Caogz8EEDJ`, //userID
    TEMPLATE_ID: `template_zucrbwm`, //templateID
    SERVICE_ID: 'service_f2x3v54'
};

export default defaultValue;
